import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/add_circle.svg'


const _hoisted_1 = { class: "card-product" }
const _hoisted_2 = { class: "content-img" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "content-text" }
const _hoisted_5 = { class: "text" }
const _hoisted_6 = { class: "name-product" }
const _hoisted_7 = { class: "tag-brand" }


import { useCartShoppingStore } from "@/store/cartshopping";


export default /*@__PURE__*/_defineComponent({
  __name: 'CardProduct.component',
  props: {
    product: {
        type: Object,
        required: true
    }
},
  setup(__props) {

const cartShop = useCartShoppingStore();



function addToCartShopping(product) {
    // Verificar si el producto ya está en el carrito
    const existingProduct = cartShop.cart.find(item => item.id === product.id);
    if (existingProduct) {
        existingProduct.quantity += 1;
        return;
    }
    cartShop.addToCart(product);
}


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: {path: `/productos/${__props.product.slug_product}`, query: { id: __props.product.id}}
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: __props.product.img_product[0],
            alt: __props.product.description_product_custom
          }, null, 8, _hoisted_3)
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("p", _hoisted_6, _toDisplayString(__props.product.name_product), 1),
        _createElementVNode("p", null, _toDisplayString(__props.product.description_product_custom), 1),
        _createElementVNode("span", _hoisted_7, _toDisplayString(__props.product.brand_product), 1)
      ]),
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = () => addToCartShopping(__props.product)),
        class: "btn btn-add-to-cart"
      }, [...(_cache[1] || (_cache[1] = [
        _createElementVNode("img", {
          src: _imports_0,
          alt: "Icon add"
        }, null, -1),
        _createTextVNode("   Agregar ", -1)
      ]))])
    ])
  ]))
}
}

})